import 'react-app-polyfill/ie9'
import '@babel/polyfill'
import React from 'react'
import { render } from 'react-dom'
import Amplify from "aws-amplify"
import * as Sentry from '@sentry/browser'
import App from './App'
import config from "./config"
import Language from './Language'
import 'url-polyfill'
import 'whatwg-fetch'
import 'intl'
import packageJson from '../package.json'

Sentry.init({
  environment: process.env.REACT_APP_CPHILL_ENV,
  dsn: "https://dcfd30735d564553807ae1a40a201599@sentry.io/1386786",
  release: packageJson.version
})

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: "cphill",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      {
        name: "cphill-www",
        endpoint: config.website.URL
      }
    ]
  }
});

render(
  <Language locale={window.bookingLocale}>
    <App />
  </Language>, 
  document.querySelector('#root')
)
